import React from "react"
import Layout from "../components/layout"
import SEO from '../components/seo'
import styled from "@emotion/styled"
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import BallIcon from "../images/ball.png"

const AboutContainer = styled.div`
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
    margin: 8rem 0;

    @media (max-width: 768px) {
        flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        margin-top: 7rem;
    }

    @media (max-width: 425px) {
        margin-bottom: 8rem;
    }
`

const AboutTitleContainer = styled.div`
    width: 600px;
    top: 0;
    bottom: 0;
    position: absolute;

    @media (max-width: 768px) {
        position: relative;
        width: 100%;
        text-align: center;
        margin-bottom: 2rem;
    }
`

const AboutTitle = styled.h1`
    position: absolute;
    top: 15px;
    left: 0;
    font-size: 5rem;
    z-index: 2;

    @media (max-width: 768px) {
        position: relative;
        font-size: 3rem;
        margin: 0;
    }

    @media (max-width: 425px) {
        font-size: 2.5rem;
    }
`

const AboutImgContainer = styled.div`
    width: 400px;
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0);

    @media (max-width: 425px) {
        width: 300px;
    }

    @media (max-width: 320px) {
        width: 290px;
    }
`

const AboutTextContainer = styled.div`
    width: 25%;
    margin: 5rem 0 0 2rem;

    @media (max-width: 1400px) {
        width: 30%;
    }

    @media (max-width: 1200px) {
        width: 40%;
    }

    @media (max-width: 768px) {
        width: 80%;
        text-align: center;
        margin: 0 auto;
        margin-top: 2rem;
    }

    @media (max-width: 425px) {
        width: 85%;
    }

    @media (max-width: 320px) {
        width: 90%;
    }
`

const AboutText = styled.p`
    font-size: 1.5rem;
    letter-spacing: 0.01rem;
    line-height: 2rem;

    @media (max-width: 425px) {
        font-size: 1.3rem;
        line-height: 1.8rem;
    }

    @media (max-width: 320px) {
        font-size: 1.2rem;
    }
`

const BallAboutImg = styled.img`
    width: 80px;
    height: 80px;
    margin-bottom: -1rem;

    @media (max-width: 768px) {
        width: 70px;
        height: 70px;
        margin-bottom: -0.75rem;
    }

    @media (max-width: 425px) {
        width: 50px;
        height: 50px;
        margin-bottom: -0.65rem;
    }
`

function AboutPage(props) {
    return(
    <div>
        <SEO title="About" />
        <Layout>
            <AboutContainer>
                <AboutTitleContainer>
                    <AboutTitle data-sal="slide-up" data-sal-easing="ease" data-sal-duration="1000">About Janis<BallAboutImg src={BallIcon} alt="bouncing ball" /></AboutTitle>
                </AboutTitleContainer>
                <AboutImgContainer>
                    <Img fluid={props.data.aboutImgOne.childImageSharp.fluid} alt="Janis with her dalmatian, Bobby" />
                </AboutImgContainer>
                <AboutTextContainer>
                    <AboutText>Janis Byrne is the New York Times bestselling author of Me &amp; Bobby McGee, a book which explores her close-knit relationship with her dalmatian. 
                        If she isn't SCUBA diving somewhere off the Florida coast or eating her favorite local pizza, she's probably writing on the beach. 
                        She lives in the Florida Keys with Bobby (of course).</AboutText>
                </AboutTextContainer>
            </AboutContainer>
        </Layout>
    </div>
    )
}

export default AboutPage

export const query = graphql`
query {
  aboutImgOne: file(relativePath: { eq: "about.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1200, quality: 100) {
        ...GatsbyImageSharpFluid
        presentationWidth
      }
    }
  }
}
`